import React from 'react'

const Abril2025 = () => {

      // scroll  function 

    // Función genérica para hacer scroll sin tocar el URL
    const scrollToId = (id) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

  return (
    <>
    
    <div className="scroll-smooth11">
                    {/* Diseño Abril 2025 */}
                    <h1 className="text-5xl font-bold mb-4">Novedades en Invu POS 3</h1>

                    <p className="text-base text-gray-600 mb-1">Feature Updates</p>
                    <p className="text-base text-gray-500 mb-6">
                      Fecha de lanzamiento: <span className="font-semibold text-gray-700">Abril 2025</span>
                    </p>


                    <ul className="list-disc list-inside mb-8 marker:text-black text-red-600 space-y-2">
                      <li
                        onClick={() => scrollToId('integraciones-de-pago')}
                        className="cursor-pointer hover:text-red-800"
                      >
                        Integraciones de Pago
                      </li>
                      <li
                        onClick={() => scrollToId('mejora-apertura-caja')}
                        className="cursor-pointer hover:text-red-800"
                      >
                        Mejora en la apertura de caja
                      </li>
                      <li
                        onClick={() => scrollToId('confirmacion-invitados')}
                        className="cursor-pointer hover:text-red-800"
                      >
                        Confirmación de Número de Invitados
                      </li>
                      {/* <li
                        onClick={() => scrollToId('correccion-bloqueados')}
                        className="cursor-pointer hover:text-red-800"
                      >
                        Corrección en ítems bloqueados por cantidad
                      </li> */}
                      <li
                        onClick={() => scrollToId('facturacion-electronica')}
                        className="cursor-pointer hover:text-red-800"
                      >
                        Facturación electrónica
                      </li>
                      <li
                        onClick={() => scrollToId('eliminar-cliente')}
                        className="cursor-pointer hover:text-red-800"
                      >
                        Eliminar cliente de una orden
                      </li>
                      <li
                        onClick={() => scrollToId('edicion-descripciones')}
                        className="cursor-pointer hover:text-red-800"
                      >
                        Edición de descripciones de ítems
                      </li>
                      <li
                        onClick={() => scrollToId('sumatoria-divididas')}
                        className="cursor-pointer hover:text-red-800"
                      >
                        Sumatoria total en órdenes divididas
                      </li>
                      <li
                        onClick={() => scrollToId('reporte-cierre-dia')}
                        className="cursor-pointer hover:text-red-800"
                      >
                        Reporte de Cierre del Día
                      </li>
                    </ul>

                    <span class="inline-flex items-center rounded-md bg-blue-50 px-4 py-1 text-md font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset mb-5">Nueva Función</span>
                    <h2 className="text-3xl font-semibold mb-4" id="integraciones-de-pago">1. Integraciones de Pago</h2>
                    <div className="mb-12">
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Ahora Invu POS es compatible con los siguientes métodos de pago:
                      </p>
                      <ul className="list-disc list-inside mb-6 text-lg">
                        <li>ADYEN</li>
                        <li>BOLD (Colombia)</li>
                      </ul>
                    </div>

                    <span class="inline-flex items-center rounded-md bg-green-50 px-4 py-1 text-md font-medium text-green-700 ring-1 ring-green-600/20 ring-inset mb-5">Mejora/Implementación</span>
                    <h2 className="text-3xl font-semibold mb-4" id="mejora-apertura-caja">2. Mejora en la apertura de caja</h2>
                    <div className="mb-12">
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Ahora al ingresar efectivo en una apertura de caja el sistema te mostrará de forma automática la suma total del efectivo en pantalla.
                      </p>
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Ya no tendrás que esperar a imprimir el comprobante para confirmar si la base está correcta.
                      </p>
                      <h3 className="text-xl font-bold mb-4 mt-6">¿Qué puedes hacer?</h3>
                      <ul className="list-disc list-inside mb-6 text-lg">
                        <li>Verificar al instante que el efectivo ingresado cumpla con la base establecida.</li>
                        <li>Evitar errores y asegurar un cuadre correcto desde el inicio del turno.</li>
                      </ul>
                      <img
                          src="https://img.invupos.com/webinvu/Software%20release/Products/Invu%20POS%203/2.png"
                          alt="Mejora en la apertura de caja"
                          className="w-3/4 object-cover rounded-2xl border border-3"
                        />
                    </div>

                    <span class="inline-flex items-center rounded-md bg-blue-50 px-4 py-1 text-md font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset mb-5">Nueva Función</span>
                    <h2 className="text-3xl font-semibold mb-4" id="confirmacion-invitados">3. Confirmación de Número de Invitados</h2>
                    <div className="mb-12">
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Al abrir una orden en el iPad, ahora verás una alerta de confirmación al ingresar más de 15 invitados o comensales.
                      </p>
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Esta función te ayudará a evitar errores y asegurar que los datos ingresados sean correctos.
                      </p>
                      <img
                          src="https://img.invupos.com/webinvu/Software%20release/Products/Invu%20POS%203/3.png"
                          alt="Alerta de confirmación de número de invitados"
                          className="w-3/4 object-cover rounded-3xl border border-3"
                        />
                    </div>

                    {/* <span class="inline-flex items-center rounded-md bg-red-50 px-4 py-1 text-md font-medium text-red-700 ring-1 ring-red-600/10 ring-inset mb-5">Correción</span>
                    <h2 className="text-3xl font-semibold mb-4" id="correccion-bloqueados">4. Corrección en ítems bloqueados por cantidad</h2>
                    <div className="mb-12">
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Cuando un ítem estaba bloqueado por cantidad, el sistema permitía agregarlo varias veces desde la lupa, siempre que cada ingreso individual respetara el límite.
                      </p>
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Este comportamiento ya fue corregido. Ahora el sistema:
                      </p>
                      <ul className="list-disc list-inside mb-6 text-lg">
                        <li>Controla la cantidad total acumulada, incluso al usar la lupa.</li>
                        <li>Bloquea automáticamente cuando se alcanza el límite.</li>
                      </ul>
                    </div> */}

                    <span class="inline-flex items-center rounded-md bg-green-50 px-4 py-1 text-md font-medium text-green-700 ring-1 ring-green-600/20 ring-inset mb-5">Mejora/Implementación</span>
                    <h2 className="text-3xl font-semibold mb-4" id="facturacion-electronica">4. Facturación electrónica</h2>
                    <div className="mb-12">
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Hemos actualizado la facturación electrónica para incluir información clave en cada documento emitido.
                      </p>
                      <h3 className="text-xl font-bold mb-4 mt-6">Ahora cada factura muestra:</h3>
                      <ul className="list-disc list-inside mb-6 text-lg">
                        <li>Descripción del producto</li>
                        <li>Precio (valor unitario)</li>
                        <li>Cantidad del producto</li>
                        <li>Valor total por producto</li>
                      </ul>
                      <h3 className="text-xl font-bold mb-4 mt-6">Beneficios:</h3>
                      <ul className="list-disc list-inside mb-6 text-lg">
                        <li>Documentos más claros y completos</li>
                        <li>Facilita auditorías y revisión de facturas</li>
                        <li>Cumple con los requerimientos fiscales más exigentes</li>
                      </ul>
                    </div>

                    <span class="inline-flex items-center rounded-md bg-blue-50 px-4 py-1 text-md font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset mb-5">Nueva Función</span>
                    <h2 className="text-3xl font-semibold mb-4" id="eliminar-cliente">5. Eliminar cliente de una orden</h2>
                    <div className="mb-12">
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Antes, si asignabas un cliente a una orden por error, no había forma de eliminarlo, solo podías reemplazarlo por otro.
                      </p>
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Ahora añadimos un botón para eliminar al cliente directamente desde la orden en caso de necesitarlo.
                      </p>
                      <img
                          src="https://img.invupos.com/webinvu/Software%20release/Products/Invu%20POS%203/6.png"
                          alt="Eliminar cliente de una orden"
                          className="w-3/4 object-cover rounded-2xl border border-3"
                        />
                    </div>

                    <span class="inline-flex items-center rounded-md bg-green-50 px-4 py-1 text-md font-medium text-green-700 ring-1 ring-green-600/20 ring-inset mb-5">Mejora/Implementación</span>
                    <h2 className="text-3xl font-semibold mb-4" id="edicion-descripciones">6. Edición de descripciones de ítems</h2>
                    <div className="mb-12">
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Antes, al editar la descripción de un ítem en una orden, el sistema no mostraba el texto previamente ingresado, lo que obligaba a escribirlo nuevamente desde cero.
                      </p>
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Ahora, al editar, el sistema presenta el texto anterior como referencia, permitiéndote hacer correcciones rápidas sin perder la información ya escrita.
                      </p>
                    </div>

                    <span class="inline-flex items-center rounded-md bg-green-50 px-4 py-1 text-md font-medium text-green-700 ring-1 ring-green-600/20 ring-inset mb-5">Mejora/Implementación</span>
                    <h2 className="text-3xl font-semibold mb-4" id="sumatoria-divididas">7. Sumatoria total en órdenes divididas</h2>
                    <div className="mb-12">
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Al dividir una orden el sistema no mostraba la suma total de todas las subórdenes, lo que dificultaba el control del monto final.
                      </p>
                      <h3 className="text-xl font-bold mb-4 mt-6">Ahora, al dividir una mesa, se muestra:</h3>
                      <ul className="list-disc list-inside mb-6 text-lg">
                        <li>El total individual por suborden</li>
                        <li>La suma total de la orden padre al pie de la pantalla</li>
                      </ul>
                    </div>

                    <span class="inline-flex items-center rounded-md bg-blue-50 px-4 py-1 text-md font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset mb-5">Nueva Función</span>
                    <h2 className="text-3xl font-semibold mb-4" id="reporte-cierre-dia">8. Reporte de Cierre del Día</h2>
                    <div className="mb-12">
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Ahora puedes generar un resumen completo al finalizar tu jornada con el Reporte de Cierre del Día en INVU POS.
                      </p>
                      <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                        Este informe te permite ver toda la actividad financiera del día y tomar acciones clave sin salir del reporte.
                      </p>
                      <h3 className="text-xl font-bold mb-4 mt-6">¿Qué puedes hacer?</h3>
                      <ul className="list-disc list-inside mb-6 text-lg">
                        <li>Ver ventas por forma de pago (efectivo, tarjeta, etc.)</li>
                        <li>Cerrar órdenes abiertas que ya fueron pagadas</li>
                        <li>Reintentar impresión de órdenes no facturadas</li>
                        <li>Realizar cierre de turno y salida de empleados</li>
                        <li>Registrar el depósito bancario del día</li>
                      </ul>
                      <h3 className="text-xl font-bold mb-4 mt-6">Beneficios:</h3>
                      <ul className="list-disc list-inside mb-6 text-lg">
                        <li>Más control sobre tus operaciones diarias</li>
                        <li>Menos errores contables</li>
                        <li>Cierre más rápido y organizado</li>
                      </ul>
                    </div>

                  </div>

    </>
  )
}

export default Abril2025